import { Fragment, useRef, useState, useContext } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTheme } from '../ThemeContext'; // Adjust the path as necessary
import ProjectNames from './Dropdowns/ProjectNames'
import Categories from './Dropdowns/IssueCategoris'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { addIssue } from '../api/api';
import {toast} from 'react-toastify'
export default function AddIssues({
  setEditing,
  handlePageUpdate,
  isEditing,
  authContext,
}) {
  const { theme } = useTheme(); // Get the theme from context
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const [pname, setPname] = useState('');
  const [category, setCategory] = useState('');

  // Formik validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
    deadline: Yup.date().required("Deadline is required"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      deadline: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const user = JSON.parse(localStorage.getItem("user"));
      const data = {
        user_id: user._id,
        title: values.name,
        description: values.description,
        deadline: values.deadline,
        project_id: pname,
        category: category,
      };

      try {
        const response = await addIssue(data);
        // console.log(response);
        toast.success("Issue Raised Successfully");
        setOpen(false); // Close the modal on success
        handlePageUpdate();
      } catch (error) {
        toast.error("Something went wrong");
        console.error("Something went wrong:", error);
      }
    },
  });

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={`relative transform overflow-hidden rounded-lg ${theme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'} text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md`}
              >
                <div className={`${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} px-4 pt-5 pb-4 sm:p-6 sm:pb-4`}>
                  <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title as="h3" className="text-lg py-4 text-center font-semibold leading-6">
                        Raise Issue
                      </Dialog.Title>
                      <form onSubmit={formik.handleSubmit}>
                        <div className="grid gap-4 mb-4 sm:grid-cols-2">
                          <div>
                            <ProjectNames pname={pname} handleChange={e => setPname(e.target.value)} />
                          </div>

                          <div>
                            <label htmlFor="name" className="block mb-2 text-sm font-medium">Title</label>
                            <input
                              type="text"
                              name="name"
                              id="name"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter issue title"
                            />
                            {formik.touched.name && formik.errors.name && (
                              <div className="text-red-600 text-sm">{formik.errors.name}</div>
                            )}
                          </div>

                          <div>
                            <Categories category={category} handleChange={e => setCategory(e.target.value)} />
                          </div>
                          <div>
                            <label htmlFor="deadline" className="block mb-2 text-sm font-medium">Deadline</label>
                            <input
                              type="date"
                              name="deadline"
                              id="deadline"
                              value={formik.values.deadline}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                            />
                            {formik.touched.deadline && formik.errors.deadline && (
                              <div className="text-red-600 text-sm">{formik.errors.deadline}</div>
                            )}
                          </div>

                          <div className='col-span-2'>
                            <label htmlFor="description" className="block mb-2 text-sm font-medium">Description</label>
                            <textarea
                              name="description"
                              id="description"
                              value={formik.values.description}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              className={`bg-gray-50 border border-gray-300 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 ${theme === 'dark' ? 'bg-gray-700 text-white border-gray-600' : ''}`}
                              placeholder="Enter detailed description"
                            />
                            {formik.touched.description && formik.errors.description && (
                              <div className="text-red-600 text-sm">{formik.errors.description}</div>
                            )}
                          </div>

                        
                        </div>
                        <div className="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse justify-between">
                          <button
                            type="submit"
                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:ml-3 sm:w-auto"
                          >
                            {isEditing ? 'Save' : 'Add'}
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:mt-0 sm:w-auto"
                            onClick={() => {
                              setOpen(false);
                              { isEditing && setEditing(false) }
                            }}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
